export const FETCH_STOPLIST_DISH = 'FETCH_STOPLIST_DISH'
export const FETCH_STOPLIST_OPTION = 'FETCH_STOPLIST_OPTION'
export const ADD_STOPLIST_OPTION_SSE = 'ADD_STOPLIST_OPTION_SSE'
export const ADD_STOPLIST_DISHES_SSE = 'ADD_STOPLIST_DISHES_SSE'
export const REMOVE_STOPLIST_OPTION_SSE = 'REMOVE_STOPLIST_OPTION_SSE'
export const ADD_MODIFIER_TO_STOPLIST = 'ADD_MODIFIER_TO_STOPLIST'
export const REMOVE_MODIFIER_FROM_STOPLIST = 'REMOVE_MODIFIER_FROM_STOPLIST'
